import React, { useCallback, useEffect, useState } from "react";
import EmployeeSelector from "../component/EmployeeSelector";
import VocabularyComponent from "../handwrite/VocabularyComponent";
import useCanvas from "../hooks/useCanvas";
import useVocabulary from "../hooks/useVocabulary";
import "../styles/TeachCanvas.css";
import Canvas from "./Canvas";
import { AI_SERVER_PATH } from "../utils/utils";
const TEACH_PATH = AI_SERVER_PATH + "/save-image";

const TeachCanvas = () => {
  const {
    mainCanvasRef,
    hiddenCanvasRef,
    clearCanvas,
    startDrawing,
    draw,
    config,
  } = useCanvas();

  const [imageLabel, setImageLabel] = useState("");
  const [selectedEmployee, setSelectedEmployee] = useState(null);

  const voc = useVocabulary();

  useEffect(() => {
    setImageLabel(voc.vocabulary?.english || "");
  }, [voc.vocabulary]);

  async function handleSend() {
    await saveToServer();
    voc.nextWord();
  }

  const saveToServer = useCallback(async () => {
    const hiddenCtx = hiddenCanvasRef.current.getContext("2d");
    hiddenCtx.drawImage(
      mainCanvasRef.current,
      0,
      0,
      config.Value.WIDTH * config.Value.ENLARGE_RATIO,
      config.Value.HEIGHT * config.Value.ENLARGE_RATIO
    );
    const dataURL = hiddenCanvasRef.current.toDataURL("image/png");

    try {
      const response = await fetch(TEACH_PATH, {
        method: "POST",
        body: JSON.stringify({
          employee: selectedEmployee.name,
          imageLabel,
          imageData: dataURL,
        }),
        headers: { "Content-Type": "application/json" },
      });

      if (response.ok) {
        console.log("Image saved to server successfully!");
        clearCanvas();
      } else {
        console.error("Error saving image to server:", response.statusText);
      }
    } catch (error) {
      console.error("Error saving image to server:", error);
    }
  }, [
    imageLabel,
    selectedEmployee,
    clearCanvas,
    mainCanvasRef,
    hiddenCanvasRef,
  ]);
  return (
    <div className="teach-container">
      <form className="teach-form" onSubmit={(e) => e.preventDefault()}>
        <EmployeeSelector
          selectedEmployee={selectedEmployee}
          setSelectedEmployee={setSelectedEmployee}
        />
        <VocabularyComponent voc={voc} />
        <div className="teach-input">
          <span>ラベル：</span>
          <label className="teach-label">{imageLabel || "..."}</label>
        </div>
        <div className="teach-button-actions">
          <button
            type="button"
            onClick={handleSend}
            className="teach-button-send"
            disabled={!selectedEmployee}
          >
            Send
          </button>
          <button
            type="button"
            onClick={clearCanvas}
            className="teach-button-clear"
          >
            Clear
          </button>
        </div>
        <Canvas
          mainCanvasRef={mainCanvasRef}
          hiddenCanvasRef={hiddenCanvasRef}
          startDrawing={startDrawing}
          draw={draw}
          stopDrawing={() => {}}
          config={config.Value}
        />
      </form>
    </div>
  );
};

export default TeachCanvas;
